<template>
  <!-- 用户管理列表 -->
  <div class="user-list">
    <el-form :inline="true" class="demo-form-inline" :loading="loading" size="mini">
      <el-form-item label="昵称">
        <el-input placeholder="输入用户名搜索" v-model="filter.nickname"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input placeholder="手机号" v-model="filter.phoneNumber"></el-input>
      </el-form-item>
      <el-form-item label="用户id">
        <el-input placeholder="用户id" v-model.number="filter.userId"></el-input>
      </el-form-item>
      <el-form-item label="邮箱">
        <el-input placeholder="邮箱" v-model="filter.email"></el-input>
      </el-form-item>
      <el-form-item label="角色">
        <el-select v-model="filter.role" placeholder="请选择角色">
          <el-option label="全部" value=""></el-option>
          <el-option label="甲方" value="1"></el-option>
          <el-option label="乙方" value="2"></el-option>
          <el-option label="默认" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="注册时间从">
        <el-date-picker v-model="filter.startTime" type="datetime" placeholder="开始时间" align="center" format="yyyy-MM-dd"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker v-model="filter.endTime" type="datetime" placeholder="结束时间" align="center" format="yyyy-MM-dd"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="最后登录时间">
        <el-date-picker v-model="filter.startOnlineTime" type="datetime" placeholder="开始时间" align="center"
          format="yyyy-MM-dd" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker v-model="filter.endOnlineTime" type="datetime" placeholder="结束时间" align="center"
          format="yyyy-MM-dd" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="账号状态">
        <el-select v-model="filter.isBlack">
          <el-option label="全部" value=""></el-option>
          <el-option label="正常" :value="0"></el-option>
          <el-option label="封禁" :value="1"></el-option>
          <el-option label="警告" :value="2"></el-option>
          <el-option label="灰名单" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <!--<el-form-item >-->
      <!--<el-radio-group v-model="filter.checkStatus">-->
      <!--<el-radio-button label="">全部</el-radio-button>-->
      <!--<el-radio-button :label="0" >未认证</el-radio-button>-->
      <!--<el-radio-button :label="1" >未审核</el-radio-button>-->
      <!--<el-radio-button :label="2" >已认证</el-radio-button>-->
      <!--<el-radio-button :label="2" >已入驻</el-radio-button>-->
      <!--<el-radio-button :label="-1" >审核未通过</el-radio-button>-->
      <!--</el-radio-group>-->
      <!--</el-form-item>-->
      <!--<el-form-item >-->
      <!--<el-radio-group v-model="filter.isPartyB">-->
      <!--<el-radio-button label="">全部</el-radio-button>-->
      <!--<el-radio-button :label="true">已入驻</el-radio-button>-->
      <!--<el-radio-button :label="false">未入驻</el-radio-button>-->
      <!--</el-radio-group>-->
      <!--</el-form-item>-->
      <el-form-item>
        <el-button type="primary" size="mini" :loading="loading" @click="fetch(1)">查询</el-button>
        <!-- <el-button type="primary" size="mini" @click="exportExcel"
          >导出</el-button
        > -->
        <!-- <el-button type="primary" size="mini" @click="exportPartAExcel">导出客户数据</el-button> -->
      </el-form-item>
      <!--<el-form-item>-->
      <!--<el-button-group>-->
      <!--<el-button @click="add_form.visible=true" size="mini">增加</el-button>-->
      <!--</el-button-group>-->
      <!--</el-form-item>-->
    </el-form>
    <el-table :data="list" size="mini">
      <!--
            <el-table-column type="expand">
                <template slot-scope="scope">
                    <el-form size="mini" >
                        <el-form-item label="账号状态">
                            <el-radio-group  v-model="scope.row.isDeleted">
                                <el-radio-button :label="true">禁用</el-radio-button>
                                <el-radio-button :label="false">不禁用</el-radio-button>
                            </el-radio-group>
                        </el-form-item>

                        <el-form-item label=" ">
                            <el-button type="primary" @click="update(scope.row)">保存</el-button>
                        </el-form-item>
                    </el-form>

                </template>
</el-table-column>
-->
      <!-- <el-table-column prop="user_id" label="userId">
        <template slot-scope="scope">
          {{ scope.row.userId || "空" }}
        </template>
      </el-table-column> -->

      <el-table-column prop="avatar" label="头像">

        <template slot-scope="scope">
          <img :src="scope.row.avatar || 'static/headshot-default.png'" width="50" height="50" />
        </template>
      </el-table-column>
      <el-table-column prop="nickname" width="140px" show-overflow-tooltip label="昵称">

        <template slot-scope="scope">
          <a :href="`${frontUrl}/resume/detail/${scope.row.userIdEnc}`" target="_blank">
            {{ scope.row.nickname || "空" }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="认证名">

        <template slot-scope="scope">
          {{ scope.row.accountName || scope.row.realName }}
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="地址"
        width="180px"
        show-overflow-tooltip
        prop="address"
      /> -->
      <el-table-column width="100px" prop="role" label="角色">
        <template slot-scope="scope">{{
          map.user.role[scope.row.role]
          }}</template>
      </el-table-column>

      <el-table-column label="账号状态" width="150">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isDeleted == 1" type="danger" size="mini">已禁用</el-tag>
          <el-tag v-else-if="scope.row.isDeleted == 2" type="warning" size="mini">警告</el-tag>
          <el-tag v-else size="mini" type="success">正常</el-tag>
          <el-tag v-if="scope.row.isLimit == 1" size="mini" type="info">灰名单</el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="fee" width="100px" label="手续费率">

        <template slot-scope="scope">
          {{ scope.row.fee }}
          <span> %</span>
        </template>
      </el-table-column>
      <el-table-column prop="phone_number" width="120px" label="手机号">

        <template slot-scope="scope">
          {{ scope.row.phoneNumber || "无" }}
        </template>
      </el-table-column>


      <el-table-column prop="email" width="120px" label="邮箱">

        <template slot-scope="scope">
          {{ scope.row.email || "无" }}
        </template>
      </el-table-column>
      <!--          <el-table-column prop="skills_tags" label="用户技能">
                   <template slot-scope="scope">
                      <span v-for="item in scope.row.skills_tags">{{item}}、</span>
                    </template>
               </el-table-column>
                <el-table-column prop="description" label="个人介绍" width="160px">
              </el-table-column>
          <el-table-column prop="email" label="邮箱" width="200px">
            <template slot-scope="scope">
              {{scope.row.email || '空'}}
            </template>
          </el-table-column>       
           <el-table-column label="入驻状态">
               <template slot-scope="scope">
                   <el-tag size="mini" type="primary" v-if="scope.row.isPartyB">已入驻</el-tag>
                   <el-tag size="mini"  type="danger" v-else>未入驻</el-tag>
               </template>
           </el-table-column>
          -->
      <el-table-column prop="create_time" sortable label="注册时间" width="160px">

        <template slot-scope="scope">
          {{ scope.row.createTime || "无" }}
        </template>
      </el-table-column>
      <el-table-column prop="userId" label="用户id">
      </el-table-column>

      <!--  -->
      <el-table-column prop="depositAmount" label="充值金额" width="160px">

        <template slot-scope="scope">
          <el-button type="text" @click="goTopUp(scope.row)">{{
            scope.row.depositAmount
            }}</el-button>
        </template>
      </el-table-column>

      <el-table-column prop="frozenAmount" label="冻结余额" width="160px">
      </el-table-column>
      <el-table-column prop="orderBillingAmount" label="结算金额" width="160px">

        <template slot-scope="scope">
          <el-button type="text" @click="goFinal(scope.row)">{{
            scope.row.orderBillingAmount
            }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="withdrawalsAmount" label="提现金额" width="160px">

        <template slot-scope="scope">
          <el-button v-if="scope.row.role != 0" type="text" @click="goWithdraw(scope.row)">{{
            scope.row.withdrawalsAmount
            }}</el-button>
          <span v-else type="text">{{ scope.row.withdrawalsAmount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="accountAmount" label="余额" width="160px" />

      <!--<el-table-column  label="账号状态" width="90px">
                <template slot-scope="scope">
                    <el-switch
                            v-model="scope.row.isDeleted" class="switch" active-color="#00A854"
                            active-text="启用" :active-value="false"
                            inactive-color="#F04134" inactive-text="禁用"
                            :inactive-value="true"
                            @change=changeSwitch($event,scope.row)>
                        />
                    </el-switch>
                </template>
            </el-table-column>-->
      <!--           <el-table-column prop="quote_num" label="已投递职位数"></el-table-column>-->
      <el-table-column prop="lastOnlineTime" sortable label="最后登录时间" width="160px">

        <template slot-scope="scope">
          {{ scope.row.lastOnlineTime || "无" }}
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right">

        <template slot-scope="scope">
          <el-dropdown size="medium" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-menu" style="font-size: 24px"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="scope.row.certificationStatus != 0"
                :command="{ action: 'check', data: scope.row }">查看认证</el-dropdown-item>
              <el-dropdown-item v-if="scope.row.certificationStatus == 0"
                :command="{ action: 'certificationDetail', data: scope.row }">去认证</el-dropdown-item>
              <el-dropdown-item :command="{ action: 'clear', data: scope.row }">清除认证</el-dropdown-item>
              <el-dropdown-item command="">
                <a target="_blank" :href="`/user_item?id=${scope.row.userIdEnc}`">编辑</a>
              </el-dropdown-item>
              <el-dropdown-item command="">
                <a target="_blank" :href="`${frontUrl}?imto=${scope.row.userIdEnc}`">联系用户</a>
              </el-dropdown-item>
              <el-dropdown-item v-if="menuList.includes('云豆充值')" :command="{ action: 'send_bean', data: scope.row }"> {{
                scope.row.role == 1 ? '发放沟通卡' : '发放投递卡' }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div>
      <el-pagination background layout="prev, pager, next" :page-size="20" @current-change="(i) => (page = i)"
        :page-count="page" :total="total">
      </el-pagination>
    </div>
    <el-dialog :title="sendUser.role == 1 ? '发放沟通卡' : '发放投递卡'" :visible.sync="dialogVisible" width="40%"
      :before-close="close" :close-on-click-modal="false">
      <el-form :model="sendForm" label-width="120px" :rules="rules" ref="sendForm">
        <el-form-item label="数量" prop="num">
          <el-input v-model.number="sendForm.num" style="width: 500px;"></el-input> &nbsp;张
        </el-form-item>
        <el-form-item label="有效期" prop="day">
          <el-input v-model.number="sendForm.day" style="width: 500px;"></el-input> &nbsp;天
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="close('sendForm')">取 消</el-button>
        <el-button type="primary" @click="dialogBeforeClose">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="titleAC" :visible.sync="dialogVisibleAC" width="40%" :before-close="closeAC">
      <el-form :model="formAC" label-width="120px" :rules="rulesAC" ref="formAC">
        <el-form-item label="姓名:" prop="name">
          <el-input clearable :disabled="isAdd" v-model.trim="formAC.name"></el-input>
        </el-form-item>
        <el-form-item label="身份证号码:" prop="idCard">
          <el-input clearable :disabled="isAdd" v-model="formAC.idCard"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="closeAC('formAC')">取 消</el-button>
        <el-button :disabled="isAdd" type="primary" @click="submitAC">确认认证</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import map from "../../datamap";
import api from "../api";
let { user, order, menu } = api;
export default {
  name: "user-list",
  data() {
    var checkNumber = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入发放云豆数量"));
      }
      if (value < 0) {
        return callback(new Error("请输入大于0的数字值"));
      }
      if (!Number.isInteger(value)) {
        callback(new Error("请输入数字值"));
      } else {
        callback();
      }
    };
    var checkday = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入有效期"));
      }
      if (value < 0) {
        return callback(new Error("请输入大于0的数字值"));
      }
      if (!Number.isInteger(value)) {
        callback(new Error("请输入数字值"));
      } else {
        callback();
      }
    };
    return {
      sendUser: {},
      menuList: [], // 权限列表
      map,
      loading: true,
      list: [],
      total: 0,
      page: 1,
      limit: 20,
      filter: {
        nickname: "",
        role: "",
        // checkStatus:'',
        phoneNumber: "",
        userId: "",
        email: "",
        // isPartyB:false,
        // isDeleted:'',
        isBlack: "",
        skillTag: "",
        startTime: "",
        startOnlineTime: '',
        endOnlineTime: '',
        endTime: "",
        description: "",
        careerExperience: "",
      },
      dialogVisible: false,
      sendForm: { num: "", day: "" },
      dialogVisibleAC: false,
      titleAC: "",
      formAC: {
        name: "",
        idCard: "",
      },
      isAdd: false,
      rulesAC: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        idCard: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
        ],
      },
      rules: {
        num: [{ required: true, validator: checkNumber, trigger: "blur" }],
        day: [{ required: true, validator: checkday, trigger: "blur" }],
      },
    };
  },
  watch: {
    page() {
      this.fetch();
    },
  },
  created() {
    this.menuList = JSON.parse(localStorage.getItem("menuList")) || [];
  },
  methods: {
    async fetch(num) {
      this.loading = true;

      if (num == 1) this.page = 1;
      let pageNum = this.page;
      let limit = this.limit;
      let { nickname, userId, role, phoneNumber, startTime, endTime, startOnlineTime, endOnlineTime, isBlack, email } =
        this.filter;
      let res = await user.list({
        pageNum: pageNum,
        limit: limit,
        email: email,
        nickName: nickname,
        userId: Number.isInteger(userId) ? userId : "",
        role,
        phoneNumber,
        startTime,
        startOnlineTime,
        endOnlineTime,
        endTime,
        isBlack,
      });
      this.list = res.data.data;
      this.total = res.data.pageinfo.totalCount;
      this.loading = false;

    },

    async update(item) {
      let { userId, isDeleted } = item;
      let res = await user.update({
        userId: Number.isInteger(userId) ? userId : "",
        isDeleted,
      });
      if (res.data.code === 200) {
        this.$message.success("更新用户成功");
        this.fetch();
      }
    },
    async exportExcel() {
      this.loading = true;
      let { nickname, userId, phoneNumber, startTime, startOnlineTime, endOnlineTime, endTime, isBlack, email } =
        this.filter;

      let obj = {
        nickname,
        userId: Number.isInteger(userId) ? userId : "",
        phoneNumber,
        startTime,
        startOnlineTime,
        endOnlineTime,
        email,
        endTime,
        isBlack,
      };
      let resp = await user.export(obj);
      let objectUrl = URL.createObjectURL(new Blob([resp.data]));
      let link = document.createElement("a");
      // console.log(link);
      link.download = decodeURIComponent("用户列表.xlsx");
      link.href = objectUrl;
      link.click();
    },
    async exportPartAExcel() {
      this.loading = true;
      let resp = await user.exportPartA();
      let objectUrl = URL.createObjectURL(new Blob([resp.data]));
      let link = document.createElement("a");
      // console.log(link);
      link.download = decodeURIComponent("客户列表.xlsx");
      link.href = objectUrl;
      link.click();
    },
    async remove(item) {
      try {
        await this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        let { userId } = item;
        let res = await api.user.remove({
          userId,
        });
        if (res.data.code === 200) {
          this.$message.success("删除数据成功");
          this.fetch();
        }
      } catch (e) {
        this.$message.success("删除数据失败");
      }
    },
    async changeSwitch(data, row) {
      let { userId } = row;
      let res = await user.enableOrDisableUser({
        userId,
      });
      if (res.data.code === 200) {
        this.$message.success("更新账号状态成功");
      } else {
        this.$message.error(data.message);
        let newData = row;
        newData.isDeleted = newData.isDeleted === true ? false : true; //恢复 原状态
        this.list[index] = newData;
      }
      /*            companyApi.updateCompanyStatus(args, res => {
                            const data = res.data;
                            if (data.code == 200) {
                                this.$message({
                                    type: 'success',
                                    message: '保存成功！',
                                });
                            } else {
                                this.$message.error(data.message);
                                let newData = row;
                                newData.isDisabled = newData.isDisabled === 1 ? 0 : 1;//恢复 原状态
                                this.tableData[index] = newData;
                            }
                        }, err => {
                            this.$message.error('提交数据失败，请稍后再试！');
                        })*/
    },
    handleCommand(command) {
      let action = command.action;
      let data = command.data;
      switch (action) {
        case "clear":
          this.cleanCertification(data);
          break;
        case "send_bean": //发云豆
          this.sendbean(data);
          break;
        case "certificationDetail":
          this.getToken(data);
          break;
        case "check":
          this.getCheck(data);
          break;

        default:
      }
    },
    async cleanCertification(row) {
      if (confirm("是否确认清除用户认证信息")) {
        let obj = {
          userId: row.userId,
        };
        let {
          data: { code },
        } = await user.cleanCertification(obj);
        if (code == 200) {
          this.$message.success("认证信息清除更新成功");
          this.fetch();
        }
      }
    },
    getCheck(row) {
      this.isAdd = true;
      this.titleAC = "查看认证";
      this.dialogVisibleAC = true;
      let userId = row.userId;
      user.getUserInfo({ userId }).then((res) => {
        if (res.data.code === 200) {
          this.formAC = res.data.data;
        }
      });
    },

    async getToken(row) {
      this.isAdd = false;
      this.titleAC = "去认证";
      this.dialogVisibleAC = true;
      this.formAC.userId = row.userId;
      this.formAC.idCard = row.idCard;
      this.formAC.name = row.name;
    },
    sendbean(row) {
      console.log(row, 'row')
      this.sendUser = row
      this.dialogVisible = true;
      this.sendForm.aesId = row.userIdEnc;
      // this.sendForm.userIdEnc = row.userIdEnc;
    },
    // 确认发云豆
    dialogBeforeClose() {
      this.$refs.sendForm.validate((valid) => {
        if (valid) {
          user.rechargeYunDou(this.sendForm).then((res) => {
            if (res.data.code === 200) {
              this.$message.success("发放成功！");
              this.close();
            }
          });
        } else {
          return false;
        }
      });
    },
    close(sendForm) {
      this.sendForm.num = null;
      this.sendForm.day = null;

      this.dialogVisible = false;
      this.$refs[sendForm].resetFields();
    },
    closeAC(formAC) {
      // this.$refs["formAC"].resetFields();
      this.dialogVisibleAC = false;
    },
    goTopUp(row) {
      this.$router.push({
        path: "/pay",
        query: {
          userId: row.userId,
        },
      });
    },
    goFinal(row) {
      this.$router.push({
        path: "/settlement",
        query: {
          userId: row.userId,
          role: row.role,
          billStatus: "3",
        },
      });
    },
    goWithdraw(row) {
      // 甲方金额跳转至充值账户提现页面
      // 乙方金额跳转至收入账户提现页面
      if (row.role == 1) {
        this.$router.push({
          path: "/withdrawal/1", // 甲方
          query: {
            userId: row.userId,
          },
        });
      } else if (row.role == 2) {
        this.$router.push({
          path: "withdrawal/2",
          query: {
            userId: row.userId,
          },
        });
      }
    },
    // 确认认证
    submitAC() {
      this.$refs["formAC"].validate((valid) => {
        if (valid) {
          user.updateStatus(this.formAC).then((res) => {
            if (res.data.code == 200) {
              this.$message.success("认证成功");
            } else {
              this.$message.error(res.data.desc);
            }
            this.fetch();
            this.formAC = {};
            this.dialogVisibleAC = false;
          });
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>

<style>
.switch .el-switch__label {
  position: absolute;
  display: none;
  color: #fff;
}

/*打开时文字位置设置*/

.switch .el-switch__label--right {
  z-index: 1;
  right: -3px;
}

/*关闭时文字位置设置*/

.switch .el-switch__label--left {
  z-index: 1;
  left: 19px;
}

/*显示文字*/

.switch .el-switch__label.is-active {
  display: block;
  color: #fff;
}

.switch.el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 50px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/user/user-list.vue